import {
  InvestmentNotificationLogDetailPage,
  InvestmentNotificationLogListPage,
  InvestmentNotificationSendPage,
} from 'apps/investcore/components/notification-log/pages';
import { Navigate } from 'react-router-dom';
import {
  DistrictDetailPage,
  DistrictListPage,
} from '../components/districts/pages';
import {
  HomeWidgetCreatePage,
  HomeWidgetDetailPage,
  HomeWidgetEditPage,
  HomeWidgetListPage,
} from '../components/home-widgets/pages';
import {
  InvestmentThemeCategoryListPage,
  InvestmentThemeFormPage,
  InvestmentThemeListPage,
} from '../components/investment-themes/pages';
import {
  ProvinceDetailPage,
  ProvinceEditPage,
  ProvinceListPage,
} from '../components/provinces/pages';
import {
  StaffAccountsCreatePage,
  StaffAccountsDetailPage,
  StaffAccountsEditPage,
  StaffAccountsListPage,
} from '../components/staff-accounts/pages';
import { WardDetailPage, WardListPage } from '../components/wards/pages';
import { OpsMcpConfigPage } from '../components/ops-mcp/pages';

const investcoreRoutes = [
  { path: '/admin/provinces', element: <ProvinceListPage /> },
  { path: '/admin/provinces/:id', element: <ProvinceDetailPage /> },
  { path: '/admin/provinces/:id/edit', element: <ProvinceEditPage /> },
  { path: '/admin/districts', element: <DistrictListPage /> },
  { path: '/admin/districts/:id', element: <DistrictDetailPage /> },
  { path: '/admin/wards', element: <WardListPage /> },
  { path: '/admin/wards/:id', element: <WardDetailPage /> },
  {
    path: '/admin/notification-logs',
    element: <InvestmentNotificationLogListPage />,
  },
  {
    path: '/admin/notification-logs/send',
    element: <InvestmentNotificationSendPage />,
  },
  {
    path: '/admin/notification-logs/:id',
    element: <InvestmentNotificationLogDetailPage />,
  },
  {
    path: '/admin/home-widgets',
    element: <HomeWidgetListPage />,
  },
  {
    path: '/admin/home-widgets/create',
    element: <HomeWidgetCreatePage />,
  },
  {
    path: '/admin/home-widgets/:id',
    element: <HomeWidgetDetailPage />,
  },
  {
    path: '/admin/home-widgets/:id/edit',
    element: <HomeWidgetEditPage />,
  },
  {
    path: '/admin/investment-themes',
    element: <InvestmentThemeListPage />,
  },
  {
    path: '/admin/investment-themes/create',
    element: <InvestmentThemeFormPage />,
  },
  {
    path: '/admin/investment-themes/:id/edit',
    element: <InvestmentThemeFormPage />,
  },
  { path: '/admin/ops-mcp', element: <OpsMcpConfigPage /> },
  {
    path: '/admin/investment-theme-categories',
    element: <InvestmentThemeCategoryListPage />,
  },
  {
    path: '/admin/staff-accounts',
    element: <StaffAccountsListPage />,
  },
  {
    path: '/admin/staff-accounts/create',
    element: <StaffAccountsCreatePage />,
  },
  {
    path: '/admin/staff-accounts/:id',
    element: <StaffAccountsDetailPage />,
  },
  {
    path: '/admin/staff-accounts/:id/edit',
    element: <StaffAccountsEditPage />,
  },
  // Wealth moved to /wealth/* — keep old URLs alive as redirects
  {
    path: '/admin/wealth/user-assignments',
    element: <Navigate to="/wealth/user-assignments" replace />,
  },
  {
    path: '/admin/wealth/user-assignments/create',
    element: <Navigate to="/wealth/user-assignments/create" replace />,
  },
  {
    path: '/admin/wealth/user-assignments/:id',
    element: <Navigate to="/wealth/user-assignments" replace />,
  },
];

export default investcoreRoutes;
